export const faqs = [
  {
    question: 'What kinds of businesses do you actually work with?',
    answer:
      'Medspas, law firms, brokers, clinics, gyms, real estate, dealerships, trades, and similar owner-run shops, usually about 3 to 30 people. If you run on appointments, consults, or inbound leads, we can usually help.',
  },
  {
    question: 'Will this disrupt how we currently work?',
    answer:
      'No. We work inside your phone, email, booking tool, or CRM. You do not need a new stack or a big retrain. We fix the gaps between those tools: slow replies, dropped follow-up, and bad handoffs.',
  },
  {
    question: "What's the difference between The Pilot and The Pro?",
    answer:
      'Pilot is one focused build: 2 or 3 workflows live in about two weeks, plus 14 days of support. Pro is the full build: 5 to 7 workflows, a Custom AI Assistant trained on your business, team training, and 30 days of support. Pilot cost credits toward Pro if you upgrade.',
  },
  {
    question: 'How do I know this will actually pay for itself?',
    answer:
      "Discovery is free. Before you buy, Audit and Diagnose puts real numbers on missed inquiries, slow follow-up, and admin time. If we do not see a clear return, we will say so. We are not here to sell work that does not pay back within a month or two.",
  },
  {
    question: 'How quickly does something go live?',
    answer:
      'The Pilot is typically live within two weeks of your discovery session. The Pro takes three to four weeks depending on the number of integrations. The Partnership retainer moves on an ongoing build cycle. Discovery, Audit, and the plan are done before any build starts, so there are no surprises mid-project.',
  },
];
